import { render, staticRenderFns } from "./InstaWidget.vue?vue&type=template&id=51ecf40b&scoped=true"
import script from "./InstaWidget.vue?vue&type=script&lang=js"
export * from "./InstaWidget.vue?vue&type=script&lang=js"
import style0 from "./InstaWidget.vue?vue&type=style&index=0&id=51ecf40b&prod&lang=scss"
import style1 from "./InstaWidget.vue?vue&type=style&index=1&id=51ecf40b&prod&lang=scss"
import style2 from "./InstaWidget.vue?vue&type=style&index=2&id=51ecf40b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecf40b",
  null
  
)

export default component.exports